import { createFileRoute } from "@tanstack/react-router"

import QuizBuilder from "@/components/Quizzes/QuizBuilder"

export const Route = createFileRoute("/_layout/quiz-management/add")({
  component: QuizBuilderRoute,
})

export function QuizBuilderRoute() {
  return <QuizBuilder mode="create" />
}
